import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ExamdojoAuthService } from '@examdojo/auth';
import { ToastService } from '@examdojo/core/toast';
import { filter, map, take } from 'rxjs';

const INTERNAL_EMAIL_DOMAINS = ['examdojo.com', 'dojostack.ai'];

export const internalUserGuard: CanActivateFn = () => {
  const authService = inject(ExamdojoAuthService);
  const toastService = inject(ToastService);
  const router = inject(Router);

  return authService.currentUser$.pipe(
    filter(Boolean),
    take(1),
    map((user) => {
      const isInternalUser = INTERNAL_EMAIL_DOMAINS.some(
        (domain) => user.email?.toLowerCase().endsWith(`@${domain.toLowerCase()}`),
      );

      if (!isInternalUser) {
        toastService.warning('Access restricted to internal users only');
        return router.createUrlTree(['/']);
      }

      return true;
    }),
  );
};
